// Renders a JSON value as formatted monospace text within a DataGrid cell.
// The value is serialised with JSON.stringify for human-readable output.
const NiceJsonCell = ({ children }) => {
  if (!children) return null;

  return (
    <span
      style={{
        fontFamily: "monospace",
        fontSize: "11px",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
      }}
    >
      {JSON.stringify(children, null, 2)}
    </span>
  );
};

export default NiceJsonCell;
